document.addEventListener("DOMContentLoaded", function initProductGalleries() {
  if (typeof Swiper === "undefined") {
    window.setTimeout(initProductGalleries, 50);
    return;
  }

  document.querySelectorAll(".product-gallery").forEach((gallery) => {
    const mainEl = gallery.querySelector(".product-gallery-swiper");
    if (!mainEl || mainEl.swiper) {
      return;
    }

    const thumbEl = gallery.querySelector(".product-gallery-thumbs-swiper");
    const mainSlides = Array.from(mainEl.querySelectorAll(".swiper-wrapper > .swiper-slide"));
    const modalEl = document.querySelector(
      '.modal--product-image[data-product-gallery-id="' + gallery.dataset.productGalleryId + '"]'
    );
    const modalSwiperEl = modalEl ? modalEl.querySelector(".product-gallery-modal-swiper") : null;
    const modalSlides = modalSwiperEl
      ? Array.from(modalSwiperEl.querySelectorAll(".swiper-wrapper > .swiper-slide"))
      : [];
    const canLoopMain = mainSlides.length > 1;
    const canLoopModal = modalSlides.length > 1;

    let thumbsSwiper = null;
    if (thumbEl) {
      thumbsSwiper = new Swiper(thumbEl, {
        slidesPerView: "auto",
        spaceBetween: 0,
        grabCursor: true,
        loop: false,
        freeMode: true,
        watchSlidesProgress: true
      });
    }

    let modalSwiper = null;
    if (modalSwiperEl) {
      modalSwiper = new Swiper(modalSwiperEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: canLoopModal,
        zoom: {
          maxRatio: 4,
          minRatio: 1,
          toggle: true
        },
        navigation: {
          nextEl: modalEl.querySelector(".product-gallery-modal-next"),
          prevEl: modalEl.querySelector(".product-gallery-modal-prev")
        },
        pagination: {
          el: modalEl.querySelector(".swiper-pagination"),
          clickable: true
        }
      });
    }

    const syncSelectedState = (swiper) => {
      const activeSlide = swiper.slides[swiper.activeIndex];
      if (!activeSlide) {
        return;
      }

      const activeMediaId = activeSlide.querySelector(".product-gallery__carousel-item")?.dataset.mediaId;

      gallery.querySelectorAll(".product-gallery__carousel-item").forEach((item) => {
        item.classList.toggle("is-selected", item.dataset.mediaId === activeMediaId);
      });

      gallery.querySelectorAll(".product-gallery__thumbnail").forEach((item) => {
        item.classList.toggle("is-nav-selected", item.dataset.mediaId === activeMediaId);
      });
    };

    const mainSwiper = new Swiper(mainEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      grabCursor: true,
      loop: canLoopMain,
      navigation: {
        nextEl: gallery.querySelector(".swiper-gallery-next"),
        prevEl: gallery.querySelector(".swiper-gallery-prev")
      },
      thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : void 0,
      on: {
        init(swiper) {
          syncSelectedState(swiper);
        },
        slideChange(swiper) {
          syncSelectedState(swiper);
        }
      }
    });

    gallery.querySelectorAll(".product-gallery__thumbnail").forEach((thumbnail) => {
      thumbnail.addEventListener("click", (event) => {
        event.preventDefault();
        const mediaId = thumbnail.dataset.mediaId;
        const targetIndex = mainSlides.findIndex((slide) => {
          return slide.querySelector('.product-gallery__carousel-item[data-media-id="' + mediaId + '"]');
        });

        if (targetIndex >= 0) {
          if (canLoopMain) {
            mainSwiper.slideToLoop(targetIndex);
          } else {
            mainSwiper.slideTo(targetIndex);
          }
        }
      });
    });

    gallery.querySelectorAll(".product-gallery__image").forEach((image) => {
      image.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
      });
    });

    gallery.querySelectorAll(".product-gallery__zoom-button").forEach((button) => {
      button.addEventListener("click", () => {
        if (!modalSwiper) {
          return;
        }

        const activeMediaId = mainSwiper.slides[mainSwiper.activeIndex]
          ?.querySelector(".product-gallery__carousel-item")
          ?.dataset.mediaId;

        const modalIndex = modalSlides.findIndex((slide) => {
          return slide.dataset.mediaId === activeMediaId;
        });

        if (modalIndex >= 0) {
          if (modalSwiper.zoom && modalSwiper.zoom.scale > 1) {
            modalSwiper.zoom.out();
          }
          if (canLoopModal) {
            modalSwiper.slideToLoop(modalIndex, 0);
          } else {
            modalSwiper.slideTo(modalIndex, 0);
          }
        }

        window.setTimeout(() => {
          modalSwiper.update();
        }, 0);
      });
    });
  });
});
